<form novalidate autocomplete="off" class="space-y-6" (submit)="onSubmit($event)">
  <!-- Header -->
  <div class="text-center">
    <!-- Icon with pulse ring -->
    <div
      class="relative mx-auto flex items-center justify-center w-14 h-14 rounded-full bg-blue-500/10 border border-blue-500/20 mb-5"
    >
      <svg
        class="relative z-10 w-6 h-6 text-blue-400"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        stroke-width="2"
        aria-hidden="true"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
        />
      </svg>
      <!-- Pulse ring -->
      <span
        class="absolute inset-0 rounded-full border border-blue-400/40 animate-ping opacity-75"
      ></span>
    </div>

    <h2
      class="text-xl sm:text-2xl font-bold bg-linear-to-r from-white via-blue-100 to-cyan-200 bg-clip-text text-transparent"
    >
      Cambiar contraseña
    </h2>
    <p class="mt-2 text-sm text-slate-400">Define una nueva contraseña segura para tu cuenta</p>
    @if (mensajeFront()?.success == true) {
      <div
        class="mt-4 inline-flex items-center gap-2 px-4 py-2 rounded-lg bg-green-500/10 border border-green-500/20 text-sm text-green-400"
      >
        <i class="bi bi-check-circle-fill"></i>
        {{ mensajeFront()!.message }}
      </div>
    } @else if (mensajeFront()?.success == false) {
      <div
        class="mt-4 inline-flex items-center gap-2 px-4 py-2 rounded-lg bg-red-500/10 border border-red-500/20 text-sm text-red-400"
      >
        <i class="bi bi-exclamation-triangle-fill"></i>
        {{ mensajeFront()!.message }}
      </div>
    }
  </div>
  @if (contraCambioExitoso() == true) {
    <div class="mt-6 text-center">
      <a
        routerLink="/auth/login"
        class="inline-flex items-center gap-2 px-4 py-2 rounded-lg bg-linear-to-r from-[#0080f3] to-[#0ea5e9] text-white font-semibold hover:shadow-lg hover:shadow-[#0080f3]/40 active:scale-[0.98] transition-all duration-200 text-sm"
      >
        <i class="bi bi-box-arrow-in-right"></i>
        Iniciar sesión
      </a>
    </div>
  } @else if (contraCambioExitoso() == false) {
    <!-- Decorative divider -->
    <div class="flex items-center gap-3">
      <div class="flex-1 h-px bg-white/5"></div>
      <svg
        class="w-4 h-4 text-slate-600"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        stroke-width="2"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
        />
      </svg>
      <div class="flex-1 h-px bg-white/5"></div>
    </div>
    <!-- New password field -->
    <div class="flex flex-col gap-1.5 group">
      <label
        for="new-password"
        class="text-slate-300 text-sm group-focus-within:text-blue-400 transition-colors"
      >
        Nueva contraseña
      </label>
      <div class="relative">
        <span
          class="absolute left-3.5 top-1/2 -translate-y-1/2 text-slate-500 group-focus-within:text-blue-400 transition-colors"
          aria-hidden="true"
        >
          <svg
            class="w-4 h-4"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            stroke-width="2"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
            />
          </svg>
        </span>
        <input
          id="new-password"
          [type]="showPassword() ? 'text' : 'password'"
          placeholder="Mínimo 8 caracteres"
          [formField]="form.newPassword"
          class="w-full pl-10 pr-3 py-2.5 border border-white/10 rounded-lg bg-white/5 text-white placeholder-slate-500 focus:border-blue-400 focus:ring-2 focus:ring-blue-500/20 outline-none transition-all duration-200 text-sm"
        />
        <button
          type="button"
          class="absolute right-3.5 top-1/2 -translate-y-1/2 text-slate-500 hover:text-blue-400 transition-colors"
          (click)="togglePasswordVisibility()"
          aria-label="Toggle password visibility"
        >
          <i class="bi" [class]="showPassword() ? 'bi-eye-slash' : 'bi-eye'"></i>
        </button>
      </div>

      <!-- Password strength indicator (visual only) -->
      <div class="flex gap-1 mt-1">
        @for (bar of [1, 2, 3, 4]; track bar) {
          <div
            class="flex-1 h-1 rounded-full transition-all duration-200"
            [class]="bar <= passwordStrength() ? strengthColor() : 'bg-white/5'"
          ></div>
        }
      </div>
      <p class="text-xs text-slate-500">
        Mínimo 8 caracteres, incluye mayúsculas, minúsculas y números.
      </p>
    </div>

    <!-- Confirm password field -->
    <div class="flex flex-col gap-1.5 group">
      <label
        for="confirm-password"
        class="text-slate-300 text-sm group-focus-within:text-blue-400 transition-colors"
      >
        Confirmar contraseña
      </label>
      <div class="relative">
        <span
          class="absolute left-3.5 top-1/2 -translate-y-1/2 text-slate-500 group-focus-within:text-blue-400 transition-colors"
          aria-hidden="true"
        >
          <svg
            class="w-4 h-4"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            stroke-width="2"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
            />
          </svg>
        </span>
        <input
          id="confirm-password"
          [type]="showPassword() ? 'text' : 'password'"
          placeholder="Repite tu nueva contraseña"
          [formField]="form.confirmPassword"
          class="w-full pl-10 pr-3 py-2.5 border border-white/10 rounded-lg bg-white/5 text-white placeholder-slate-500 focus:border-blue-400 focus:ring-2 focus:ring-blue-500/20 outline-none transition-all duration-200 text-sm"
        />
        <button
          type="button"
          class="absolute right-3.5 top-1/2 -translate-y-1/2 text-slate-500 hover:text-blue-400 transition-colors"
          (click)="togglePasswordVisibility()"
          aria-label="Toggle password visibility"
        >
          <i class="bi" [class]="showPassword() ? 'bi-eye-slash' : 'bi-eye'"></i>
        </button>
      </div>
    </div>

    <!-- Submit button -->
    <button
      type="submit"
      class="w-full py-3 bg-linear-to-r from-[#0080f3] to-[#0ea5e9] text-white font-semibold rounded-lg hover:shadow-lg hover:shadow-[#0080f3]/40 active:scale-[0.98] transition-all duration-200 text-sm"
    >
      Guardar nueva contraseña
    </button>
  }
</form>
